import { render, staticRenderFns } from "./LoadLeftUnpaidPrincipal.vue?vue&type=template&id=4ade9824&scoped=true&"
import script from "./LoadLeftUnpaidPrincipal.vue?vue&type=script&lang=ts&"
export * from "./LoadLeftUnpaidPrincipal.vue?vue&type=script&lang=ts&"
import style0 from "./LoadLeftUnpaidPrincipal.vue?vue&type=style&index=0&id=4ade9824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade9824",
  null
  
)

export default component.exports